/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    // e.target // newly activated tab
    // e.relatedTarget // previous active tab

    var $target = $(e.target);
    var $relatedTarget = $(e.relatedTarget);

    $target.addClass('active');
    $relatedTarget.removeClass('active');

    $.smoothScroll({
      scrollTarget: $target.attr('href'),
      offset: -100,
      easing: 'easeInOutCubic'
    });

  });
});

